// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
export const getLoader = state => state.customerOverviewReducer.loading;
export const getBookshopCustomer = state => state.customerOverviewReducer.bookshopCustomer;
export const getValue = state => state.customerOverviewReducer.value;
export const getValueStatus = state => state.customerOverviewReducer.valueStatus;
export const getConfirmModal = state => state.customerOverviewReducer.isOpenConfirmModal;
